import createCaptionsPlugin from "./createCaptionsPlugin";

export default createCaptionsPlugin;
